import { render, staticRenderFns } from "./EditableUserAvatar.vue?vue&type=template&id=c2d1a75e&"
import script from "./EditableUserAvatar.vue?vue&type=script&lang=js&"
export * from "./EditableUserAvatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports